import React, { useEffect, useState } from 'react';
import Header from './components/Header';
import Home from './components/Home';
import About from './components/About';
import Skills from './components/Skills';
import Achievement from './components/Achievement';
import Projects from './components/Projects';
import KpiLibrary from './components/KpiLibrary';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollReveal from 'scrollreveal';
import Typed from 'typed.js';

import '@fortawesome/fontawesome-free/css/all.min.css';

const App = () => {
  const [theme, setTheme] = useState(() => localStorage.getItem('portfolio-theme') || 'dark');

  const toggleTheme = () => {
    setTheme((currentTheme) => (currentTheme === 'dark' ? 'light' : 'dark'));
  };

  useEffect(() => {
    document.body.classList.toggle('light-mode', theme === 'light');
    localStorage.setItem('portfolio-theme', theme);
  }, [theme]);

  useEffect(() => {
    const isCompactHero = window.innerWidth <= 768;

    ScrollReveal({
      distance: isCompactHero ? '24px' : '80px',
      duration: 2000,
      delay: 200,
    });

    ScrollReveal().reveal('.home-content, .heading', { origin: isCompactHero ? 'bottom' : 'top' });
    ScrollReveal().reveal('.home-img, .portfolio-box, .kpi-card, .contact form', { origin: 'bottom' });
    ScrollReveal().reveal('.about-img', { origin: 'left' });
    ScrollReveal().reveal('.about-content', { origin: 'right' });

    const typed = new Typed('.multiple-text', {
      strings: [
        'Supply Chain Analyst',
        'Logistics Analyst',
        'Inventory Analyst',
        'Data Analyst',
        'Reporting Analyst',
        'Power BI Developer',
        'Dashboard Developer',
        'Workflow Automator',
        'WordPress SEO Specialist',
      ],
      typeSpeed: 70,
      backSpeed: 70,
      backDelay: 1000,
      loop: true,
    });

    return () => {
      typed.destroy();
    };
  }, []);

  return (
    <>
      <Header theme={theme} onThemeToggle={toggleTheme} />
      <Home />
      <About />
      <Skills />
      <Projects />
      <KpiLibrary />
      <Achievement/>
      <Contact />
      <Footer />
    </>
  );
};

export default App;
